import { render, staticRenderFns } from "./Termo.vue?vue&type=template&id=314159d3&scoped=true&"
import script from "./Termo.vue?vue&type=script&lang=js&"
export * from "./Termo.vue?vue&type=script&lang=js&"
import style0 from "./Termo.vue?vue&type=style&index=0&id=314159d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314159d3",
  null
  
)

export default component.exports